import { render, staticRenderFns } from "./SuperBonoView.vue?vue&type=template&id=1a2100ee&"
import script from "./SuperBonoView.vue?vue&type=script&lang=js&"
export * from "./SuperBonoView.vue?vue&type=script&lang=js&"
import style0 from "./SuperBonoView.vue?vue&type=style&index=0&id=1a2100ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports